import { Outlet } from 'react-router'

import { TopNav } from '../TopNav'

export const Layout = () => {
  return (
    <div className="grid h-dvh grid-rows-[auto_minmax(0,1fr)]">
      <header className="min-w-0">
        <TopNav />
      </header>
      <main className="min-h-0 min-w-0">
        <Outlet />
      </main>
    </div>
  )
}
